import React from 'react';
import {useTranslation} from 'react-i18next';
import {useGetUserClientStatQuery} from '../../../../../redux/userClientsApi';
import {monthNow} from '../../../../../assets/utils/dateUtils';
import LightGreenButton from '../../../../../Components/Buttons/LightGreenButton';
import GridTableHead from '../../../../../Components/GridTableHead/GridTableHead';
import {userQualifications} from '../../../../../assets/utils/translatersFunc';
import styles from './StatsTable.module.css';

interface StatsTableProps {
	clientId: number;
	selectedMonth?: string;
	showTable: boolean;
}

const StatsTable: React.FC<StatsTableProps> = ({
	clientId,
	selectedMonth,
	showTable,
}) => {
	const {t} = useTranslation();
	const [visibleCount, setVisibleCount] = React.useState(20);

	// Запрос данных статистики
	const {data: statsData, isLoading} = useGetUserClientStatQuery(
		{
			month: selectedMonth || monthNow(),
			client_id: clientId,
		},
		{
			skip: !showTable,
		},
	);

	// Если не показана таблица, не рендерим ничего
	if (!showTable) {
		return null;
	}

	// Если загружается, показываем спиннер
	if (isLoading) {
		return <div className={styles.spinner}>{t('Завантаження...')}</div>;
	}

	// Если данных нет
	if (!statsData?.months || statsData.months.length === 0) {
		return null; // Не показываем ничего, если данных нет
	}

	const stats = statsData.months.slice(0, visibleCount);

	// Настройка колонок для статистики
	const columns = [
		t('Місяць'),
		t('Кваліфікація'),
		t('Бали'),
		t('Бонус'),
		t('Премія'),
		t('Кешбек'),
		t('Оптіма'),
	];
	const gridTemplate = '110px 120px 70px 90px 50px 60px 50px';

	return (
		<div className={styles.wrapper}>
			<div className={styles.scroll}>
				<div className={styles.tableHeadWrapper}>
					<GridTableHead
						columns={columns}
						gridTemplateColumns={gridTemplate}
						customClassName={styles.gridTableHead}
					/>
				</div>
				{stats.map((stat, index) => (
					<div
						key={`${stat.month}-${index}`}
						className={styles.row}
						style={{gridTemplateColumns: gridTemplate}}
					>
						<div className={`${styles.cell} ${styles.colMonth}`}>
							{stat.month}
						</div>
					<div className={`${styles.cell} ${styles.colQualification}`}>
						{(() => {
							const userQlfc = userQualifications.find((q) => q.value === stat.qlfc);
							return (
								<span
									className={styles.qualificationBadge}
									style={{
										background: userQlfc?.background || 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
									}}
								>
									{stat.qlfc_name}
								</span>
							);
						})()}
					</div>
						<div className={`${styles.cell} ${styles.colPoints}`}>
							{stat.points}
						</div>
						<div className={`${styles.cell} ${styles.colBonus}`}>
							{stat.bonus}
						</div>
						<div className={`${styles.cell} ${styles.colPremia}`}>
							{stat.premia}
						</div>
						<div className={`${styles.cell} ${styles.colCashback}`}>
							{stat.cashback}
						</div>
						<div className={`${styles.cell} ${styles.colOptima}`}>
							{stat.optima}
						</div>
					</div>
				))}
			</div>

			{statsData.months.length > visibleCount && (
				<div className={styles.actions}>
					<LightGreenButton
						text={t('Показати ще')}
						onClick={() => setVisibleCount((v) => v + 20)}
						type="button"
					/>
				</div>
			)}
		</div>
	);
};

export default StatsTable;
